import { HEADQUARTERS_PERMISSIONS } from "../facilities/headquarters.permissions";
import { OWNERS_PERMISSIONS } from "../admin/owners.permissions";
import { OPERATION_TYPES_PERMISSIONS } from "../parameters/operation-types.permissions";
import { WAREHOUSES_PERMISSIONS } from "../facilities/warehouses.permissions";
import { INBOUND_TYPES_PERMISSIONS } from "../parameters/inbound-types.permissions";

export const UTILS_PERMISSIONS = {
  IMPORT_EXCEL: 'import_excel',
} as const;

export const UTILS_PERMISSION_LIST = [
  UTILS_PERMISSIONS.IMPORT_EXCEL,
] as const;

/**
 * Overrides para módulos cuyo permiso de importación no sigue
 * la convención import_{nombreModulo}.
 */
const IMPORT_PERMISSION_OVERRIDES: Readonly<Record<string, string>> = {
  headquarters: HEADQUARTERS_PERMISSIONS.IMPORT_EXCEL,
  owners: OWNERS_PERMISSIONS.IMPORT_EXCEL,
  operation_types: OPERATION_TYPES_PERMISSIONS.IMPORT_EXCEL,
  warehouses: WAREHOUSES_PERMISSIONS.IMPORT_EXCEL,
  inbound_types: INBOUND_TYPES_PERMISSIONS.IMPORT_EXCEL,
};

/**
 * Construye el permiso de importación a partir del nombre del módulo.
 *
 * Ejemplos:
 * - warehouses -> import_warehouses
 * - owners -> import_owners
 * - headquarters -> import_headquarter (override)
 */
export function resolveImportPermissionByModule(moduleName: string): string {
  const normalizedModule = moduleName.trim().toLowerCase().replace(/-/g, '_');
  if (!normalizedModule) return '';
  return IMPORT_PERMISSION_OVERRIDES[normalizedModule] ?? `import_${normalizedModule}`;
}
